<template>
    <!--<div class="test" style="height: 480px">-->
        <!--<ul>-->
            <!--<div v-for="item in arr" style="text-align: center">{{item}}</div>-->
            <!--<div v-for="item in newArr" style="text-align: center;margin-top: 50px">{{item}}</div>-->
        <!--</ul>-->
    <!--</div>-->
  <div>
      <div>
        <img src="../../assets/images/product/banner.png" style="width: 100%;display: block">
      </div>

      <div class="product" style="padding: 20px;">
          <div class="content">
              <div class="main_container" style="min-width: 180px;" v-show="leftShow">
                  <div style="height: 111px;padding-right: 20px">
                      <div class="product-title" style="margin-left: 20px;height: 100%">
                          <div class="flod"><i class="el-icon-s-home" style="color: #fff"></i></div>
                          <div class="recommend-article" style="font-size: 24px;height: 70px;padding-top: 10px;">产品目录</div>
                          <div class="article-item"  :class="{'selecteds':flag === 0}" @click="changeBackground(0,0)"  style="font-size: 14px">
                              <span style="font-size: 16px">家电产品系列</span>
                              <p style="font-size: 12px;color: rgba(102,102,102,1);">Home Applicances Product Line</p>
                          </div>
                          <div class="article-item"  :class="{'selecteds':flag === 1}" @click="changeBackground(1,1)" style="margin-top: 30px;font-size: 14px">
                              <span style="font-size: 16px">电表产品系列</span>
                              <p style="font-size: 12px;color: rgba(102,102,102,1);">Smart Meters Energy Product Line</p>
                          </div>
                          <div class="article-item"  :class="{'selecteds':flag === 2}" @click="changeBackground(2,2)"  style="margin-top: 30px;font-size: 14px">
                              <span style="font-size: 16px">电机产品系列</span>
                              <p style="font-size: 12px;color: rgba(102,102,102,1);">Motor Control Product Line</p>
                          </div>
                          <div class="article-item" :class="{'selecteds':flag === 3}" @click="changeBackground(3,3)"   style="margin-top: 30px;font-size: 14px">
                              <span style="font-size: 16px">电脑数据产品系列</span>
                              <p style="font-size: 12px;color: rgba(102,102,102,1);">Connectivity Application Product Line</p>
                          </div>
                        <div class="article-item" :class="{'selecteds':flag === 4}" @click="changeBackground(4,4)"  style="margin-top: 30px;font-size: 14px">
                          <span style="font-size: 16px">动力电源产品系列</span>
                          <p style="font-size: 12px;color: rgba(102,102,102,1);">High Power Product Line</p>
                        </div>
                          <div class="article-item"   :class="{'selecteds':flag === 5}" @click="changeBackground(5,5)"  style="margin-top: 30px;font-size: 14px">
                              <span style="font-size: 16px">智能终端产品系列</span>
                              <p style="font-size: 12px;color: rgba(102,102,102,1);">Smart Power Product Line</p>
                          </div>
                          <div class="article-item"  :class="{'selecteds':flag === 6}" @click="changeBackground(6,6)"  style="margin-top: 25px;font-size: 14px">
                              <span style="font-size: 16px">附录</span>
                              <p style="font-size: 12px;color: rgba(102,102,102,1);">Appendix</p>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="toolbar" style="max-width: 1180px">
                  <div class="flod"><i class="el-icon-s-fold" @click="fullScreen"></i></div>
                  <div style="height: 80px;">
                    <div style="float: left;margin-top: 10px;">
                      <span style="font-size: 24px">产品信息</span>
                    </div>
                    <div style="float: right;margin-top: 10px">
                      <img src="../../assets/images/product/excel.png">
                      <span style="color: rgba(90,204,155,1);">下载Excel表格</span>
                      <el-button type="primary" @click="reset">重置筛选条件</el-button>
                      <!--<el-button type="primary">显示/隐藏列</el-button>-->
                    </div>
                  </div>

                  <div>

                    <el-table :data="tableData" style="width: 100%" stripe  highlight-current-row border>
                      <el-table-column prop="chipLists" width="120" fixed>
                      <template slot="header" slot-scope="scope" style="width: 120px;">
                      <div class="table-header">
                      <div class="chinese-header">芯片型号</div>
                      <div class="english-header">Part Number</div>
                      </div>
                      <div class="header-select">
                      <div class="header-select-box">
                      <ul>
                      <li class="table-li" v-for="(item,index) in chipList"
                      :key="index"
                      :class="{'selected':chipFlag == index}"
                      @click="getChipValue(item,index)">{{item}}</li>
                      </ul>
                      </div>
                      </div>
                      </template>
                      </el-table-column>



                      <el-table-column prop="memoryLists" width="150">
                      <template slot="header" slot-scope="scope" style="width: 150px;">
                      <div class="table-header">
                      <div class="chinese-header" style="width: 150px">闪存(字节)</div>
                      <div class="english-header" style="width: 150px">Flash ROM（Byte）</div>
                      </div>
                      <div class="header-select" style="width: 150px">
                      <div class="header-select-box" style="width: 120px;margin-left: 15px;">
                      <ul>
                      <li class="table-li" v-for="(item,index) in memoryList"
                      :key="index"
                      :class="{'selected':memoryFlag == index}"
                      @click="getMemoryValue(item,index)">{{item}}</li>
                      </ul>
                      </div>
                      </div>
                      </template>
                      </el-table-column>


                      <el-table-column prop="memoryLists" width="150">
                        <template slot="header" slot-scope="scope" style="width: 150px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 150px">闪存(字节)</div>
                            <div class="english-header" style="width: 150px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 150px">
                            <div class="header-select-box" style="width: 120px;margin-left: 15px;">
                              <ul>
                                <li class="table-li" v-for="(item,index) in memoryList"
                                    :key="index"
                                    :class="{'selected':memoryFlag == index}"
                                    @click="getMemoryValue(item,index)">{{item}}</li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="memoryLists" width="150">
                        <template slot="header" slot-scope="scope" style="width: 150px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 150px">闪存(字节)</div>
                            <div class="english-header" style="width: 150px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 150px">
                            <div class="header-select-box" style="width: 120px;margin-left: 15px;">
                              <ul>
                                <li class="table-li" v-for="(item,index) in memoryList"
                                    :key="index"
                                    :class="{'selected':memoryFlag == index}"
                                    @click="getMemoryValue(item,index)">{{item}}</li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="memoryLists" width="150">
                        <template slot="header" slot-scope="scope" style="width: 150px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 150px">闪存(字节)</div>
                            <div class="english-header" style="width: 150px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 150px">
                            <div class="header-select-box" style="width: 120px;margin-left: 15px;">
                              <ul>
                                <li class="table-li" v-for="(item,index) in memoryList"
                                    :key="index"
                                    :class="{'selected':memoryFlag == index}"
                                    @click="getMemoryValue(item,index)">{{item}}</li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="memoryLists" width="150">
                        <template slot="header" slot-scope="scope" style="width: 150px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 150px">闪存(字节)</div>
                            <div class="english-header" style="width: 150px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 150px">
                            <div class="header-select-box" style="width: 120px;margin-left: 15px;">
                              <ul>
                                <li class="table-li" v-for="(item,index) in memoryList"
                                    :key="index"
                                    :class="{'selected':memoryFlag == index}"
                                    @click="getMemoryValue(item,index)">{{item}}</li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="memoryLists" width="150">
                        <template slot="header" slot-scope="scope" style="width: 150px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 150px">闪存(字节)</div>
                            <div class="english-header" style="width: 150px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 150px">
                            <div class="header-select-box" style="width: 120px;margin-left: 15px;">
                              <ul>
                                <li class="table-li" v-for="(item,index) in memoryList"
                                    :key="index"
                                    :class="{'selected':memoryFlag == index}"
                                    @click="getMemoryValue(item,index)">{{item}}</li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="memoryLists" width="150">
                        <template slot="header" slot-scope="scope" style="width: 150px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 150px">闪存(字节)</div>
                            <div class="english-header" style="width: 150px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 150px">
                            <div class="header-select-box" style="width: 120px;margin-left: 15px;">
                              <ul>
                                <li class="table-li" v-for="(item,index) in memoryList"
                                    :key="index"
                                    :class="{'selected':memoryFlag == index}"
                                    @click="getMemoryValue(item,index)">{{item}}</li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="memoryLists" width="300">
                        <template slot="header" slot-scope="scope" style="width: 300px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 300px">闪存(字节)</div>
                            <div class="english-header" style="width: 150px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 300px">

                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="memoryLists" width="480">
                        <template slot="header" slot-scope="scope" style="width: 480px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 480px">闪存(字节)</div>
                            <div class="english-header" style="width: 480px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 430px">
                            <div class="header-select-box" style="width: 120px;margin-left: 15px;">
                              <ul>
                                <li class="table-li" v-for="(item,index) in memoryList"
                                    :key="index"
                                    :class="{'selected':memoryFlag == index}"
                                    @click="getMemoryValue(item,index)">{{item}}</li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="memoryLists" width="500">
                        <template slot="header" slot-scope="scope" style="width: 500px;">
                          <div class="table-header">
                            <div class="chinese-header" style="width: 500px">闪存(字节)</div>
                            <div class="english-header" style="width: 500px">Flash ROM（Byte）</div>
                          </div>
                          <div class="header-select" style="width: 500px">
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>







              </div>
          </div>
      </div>
  </div>
</template>

<script>
  import api from '@/http/request'
  export default {
    name: "product",
    data () {
      return {
        flag: -1,
        leftShow: true,
        isCollapse: true,
        isActive: 0,
        leftCol: 0,
        rightCol: 20,
        fullScreenFlag: 1,
        ListTest:[],
        tableData: [],
        chipFlag: -1,
        memoryFlag: -1,
        storageFlag: -1,
        cpuhzFlag: -1,
        voltageFlag: -1,
        ioFlag: -1,
        breakSourceFlag: -1,
        breakSourceFlag1: -1,
        timerFlag: -1,
        chipList: ['SH79F081B','SH79F081B','SH79F081B','SH79F081B','SH79F081B'],
        memoryList: ['8K','16K','32K','64K'],
        storageList: ['256','512','768','1024'],
        cpuhzList: ['400K-16M','32K-12.3M','30K-16.6M','2M-12M'],
        voltageList: ['3.6~5.5','2.0~5.5','2.8~5.5'],
        ioList: ['14','26','30'],
        breakSourceList: ['3x16bits','4x16bits'],
        breakSourceList1: ['3x16bits','4x16bits'],
        timerList: ['3x16bits','4x16bits'],
        req: {
          chip: '',
          memory: '',
          storage: '',
          cpuhz: '',
          voltage: '',
          io: '',
          breakSource: '',
          timer: '',
          breakSource1: '',
        },
      }
    },
    watch: {
      '$router'(to,from){
        if(to.path === '/api/getListTest'){
          this.message = this.$router.query.msg;
        }
      }
    },
    mounted: function(){
      this.getProductList();
      console.log('this.$http',this.$http)
    },

    methods: {
      getProductList:function(){
        api.http_mock('/api/getProductList').then(res => {
          this.tableData = res;
          console.log("res1---->",this.tableData)
        })
      },
      changeBackground (number, type) {
        this.flag = number
      },
      getChipValue:function (item,index) {
        this.chipFlag = index;
        this.req.chip = item;
        this.getProductListByCondition();
      },
      getMemoryValue:function (item,index) {
        this.memoryFlag = index;
        this.req.memory = item;
        this.getProductListByCondition();
      },
      getStorageValue:function (item,index) {
        this.storageFlag = index;
        this.req.storage = item;
        this.getProductListByCondition();
      },
      getCpuhzValue:function (item,index) {
        this.cpuhzFlag = index;
        this.req.cpuhz = item;
        this.getProductListByCondition();
      },
      getVoltageValue:function (item,index) {
        this.voltageFlag = index;
        this.req.voltage = item;
        this.getProductListByCondition();
      },
      getIoValue:function (item,index) {
        this.ioFlag = index;
        this.req.io = item;
        this.getProductListByCondition();
      },
      getBreakSourceValue:function (item,index) {
        this.breakSourceFlag = index;
        this.req.breakSource = item;
        this.getProductListByCondition();
      },
      getBreakSourceValue1:function (item,index) {
        this.breakSourceFlag1 = index;
        this.req.breakSource1 = item;
        this.getProductListByCondition();
      },
      getTimerValue:function (item,index){
        this.timerFlag = index;
        this.req.timerFlag = item;
        this.getProductListByCondition();
      },
      getProductListByCondition:function(){
        this.$http.get('/api/getListTest',{params:this.req}).then(res => {
          this.tableData = res.data;
          console.log("res2---->",this.tableData.data)
        })
      },
      reset:function () {
        this.chipFlag = -1;
        this.memoryFlag = -1;
        this.storageFlag = -1;
        this.cpuhzFlag = -1;
        this.voltageFlag = -1;
        this.ioFlag = -1;
        this.timerFlag = -1;
        this.breakSourceFlag = -1;
        this.breakSourceFlag1 = -1;
      },
      fullScreen:function () {
        if(this.fullScreenFlag === 0) {
          this.leftShow = false;
          this.fullScreenFlag = 1;
        } else {
          this.leftShow = true;
          this.fullScreenFlag = 0;
        }
      },
    }
  }


    // import api from '@/http/request'
    //
    // export default {
    //     name: "test",
    //     data() {
    //         return {
    //             arr: [{id: 1, name: '1', age: 11}, {id: 2, name: '2', age: 22}, {id: 3, name: '3', age: 33}],
    //             newArr: [],
    //         }
    //     },
    //     created() {
    //       // this.getData();
    //     },
    //     mounted: function () {
    //         this.test();
    //     },
    //     methods: {
    //         test: function () {
    //             // 声明arr原数组
    //             let arr = [{id: 1, name: '1', age: 11}, {id: 2, name: '2', age: 22}, {id: 3, name: '3', age: 33}];
    //             // map方法会创建一个新的数组，用newArr接受返回的数组，返回的结果是执行函数function过后的结果
    //             this.newArr = arr.map(function (map,i) {
    //                 // 取出的id为数组原数组中每个对象对应id的值
    //                 let j = arr[i].id;
    //                 // 将id由数字类型转换成字符串
    //                 let k = j.toString();
    //                 // 生成新数组数据
    //                 const dict = {[k]: arr[i]};
    //                 // 新数据返回
    //                 return dict;
    //             });
    //         }
    //     }
    // }
</script>

<style>
  /*html, body{*/
    /*margin: 0;*/
    /*height: 100%;*/
  /*}*/
  /*.main{*/
    /*background:#ccc;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*margin: auto;*/
    /*min-width: 1000px;*/
  /*}*/

  /*.content{*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*display: table;*/
  /*}*/
  /*.toolbar{*/
    /*width: 85%;*/
    /*height: 100%;*/
    /*display: table-cell;*/
  /*}*/
  /*.main_container{*/
    /*display: table-cell;*/
    /*width: 15%;*/
    /*height: 100%;*/
  /*}*/



  /*.product .el-table__footer-wrapper, .el-table__header-wrapper { background-color: rgba(108,152,255,1); }*/
  /*.el-table thead.is-group th {  !*! autoprefixer: off *! background-color: rgba(108,152,255,1);  !* autoprefixer: on *! }*/
  /*.product li { color: #fff }*/
  /*.product .el-table th>.cell { color: #333 !important;  }*/
  /*.product .table-content { overflow:auto;height: 150px;width: 120px;background: #fff;margin-left: 5px; }*/
  /*.product .table-li { color: rgba(102, 102, 102, 1);height: 35px }*/
  /*!*.product .table-li:hover { background: #b2c8cb}*!*/
  /*.product .el-table thead.is-group th { background: rgba(239,245,255,1) !important;}*/
  /*.product .selected { background-color: rgba(239,245,255,1); }*/
  /*.product .flod { font-size: 24px }*/
  /*.product tr {height: 72px}*/
  /*.table-header { height: 72px;font-size: 16px;text-align: center;padding-left: 0px !important; }*/
  /*.el-table th div { display: block;text-align: center;padding: 0px !important; }*/
  /*.product .chinese-header {width: 120px;height: 36px;border-right: 1px solid #EBEEF5}*/
  /*.product .english-header {width: 120px;height: 36px;font-size: 14px;color: #666666;border-bottom: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5}*/
  /*.product .header-select {width: 120px;height: 180px;border-right: 1px solid #EBEEF5;}*/
  /*.product .header-select-box {*/
    /*width: 104px;height: 160px;margin-left: 8px;*/
    /*overflow:auto;background-color: #fff;border-radius: 5px;margin-top: 10px;*/
    /*margin-top: 10px;*/
  /*}*/
  /*.product .el-table td, .el-table th {*/
    /*padding: 0px !important;*/
    /*text-align: center;*/
    /*border-right: 1px solid #EBEEF5;*/
  /*}*/
  /*.product .el-table th>.cell {*/
    /*background-color: rgba(239,245,255,1);*/
  /*}*/
  /*.el-table__body tr.current-row>td {*/
    /*background-color: #DDE9FF;*/
  /*}*/

  /*.product .article-item {*/
    /*cursor: pointer;*/
  /*}*/

  /*.selecteds {*/
    /*background-color: #4A90E2;*/
  /*}*/
</style>






















<!--<template>-->
  <!--<div class="header">-->
    <!--&lt;!&ndash;<img src="../assets/images/login/logo.png" style="float: left;max-width: 95px;max-height: 76px;padding-top: 40px;border: 0">&ndash;&gt;-->
    <!--<ul class="menus" style="min-width: 900px;">-->
      <!--<li ><a href="/homes">首页</a></li>-->
      <!--<li >-->
        <!--<p style="display: inline-block;width: 120px">-->
          <!--<a>产品</a>-->

        <!--</p>-->
        <!--<ul style=";margin-left: 50px;position: absolute;background-color: #fff;display: block;margin-top:-0.5rem">-->
          <!--<li style="line-height: 30px"><a href="/product" style="color: #333333;font-size: 18px;line-height: 30px">资料分类</a></li>-->
          <!--<li style="line-height: 30px"><a href="/detaile" style="color: #333333;font-size: 18px;line-height: 30px">产品详情</a></li>-->
        <!--</ul>-->
      <!--</li>-->

      <!--<li>-->
        <!--<a>工具与资料</a>-->
        <!--<ul style="display: none">-->
          <!--<li>资料分类</li>-->
        <!--</ul>-->
      <!--</li>-->

      <!--<li>-->
        <!--<a>新闻</a>-->
        <!--<ul style="display: none">-->
          <!--<li>信息更新</li>-->
        <!--</ul>-->
      <!--</li>-->

      <!--<li>-->
        <!--<a>关于中颖</a>-->
        <!--<ul style="display: none">-->
          <!--<li>关于中颖</li>-->
          <!--<li>中颖大记事</li>-->
          <!--<li>招聘</li>-->
          <!--<li>联系我们</li>-->
        <!--</ul>-->
      <!--</li>-->

      <!--<li>-->
        <!--<a>投资者关系</a>-->
        <!--<ul style="display: none">-->
          <!--<li>经销商关系</li>-->
        <!--</ul>-->
      <!--</li>-->

      <!--<li style="margin-left: 40px">-->
        <!--<el-input class="menus-search" placeholder="请输入内容" style="width: 373px;">-->
          <!--<el-select></el-select>-->
          <!--<el-button slot="append" icon="el-icon-search" size="small" ></el-button>-->
        <!--</el-input>-->
      <!--</li>-->

      <!--<li>-->
        <!--<a href="/login" style="font-size: 16px;color: #4A90E2">登录</a>-->
        <!--<span style="color: #4A90E2;">|</span>-->
        <!--<a href="/register" style="font-size: 16px;margin-left: 0;color: #4A90E2">注册</a>-->
      <!--</li>-->
    <!--</ul>-->
  <!--</div>-->
<!--</template>-->


<!--<script>-->
  <!--export default {-->
    <!--name: "header",-->
    <!--data() {-->
      <!--return{-->

      <!--}-->
    <!--},-->
  <!--}-->
<!--</script>-->

<!--<style>-->
  <!--.header { background-color: #ffffff;min-width: 900px;height: 80px !important;position: relative;display: block }-->
  <!--.header .menus  { list-style:none;text-align: center;padding-top: 20px }-->
  <!--.header > ul > li > a {  font-size: 24px;color: #333333;margin-left: 40px;cursor: pointer}-->
  <!--.header .menus > li  {  position: relative;vertical-align: top;display: inline;width:120px;height:88px}-->
  <!--.header .login-register > a { text-decoration: none;font-size: 12px;color: #4A90E2; }-->
  <!--.header li { width: 72px }-->
  <!--.header >* { display: inline-block;line-height: 80px;vertical-align: middle }-->
<!--</style>-->



// WEBPACK FOOTER //
// src/pages/test/test.vue